<template>
  <modal :open="open" :width="720">
    <template #header>
      <modal-header variant="cross" :saving="loading" @cancel="close()" />
    </template>

    <div class="mt-6 flex flex-col gap-y-4">
      <p class="text-body whitespace-pre-wrap">
        {{ message }}
      </p>

      <div class="flex justify-end gap-x-3 mt-6">
        <custom-button variant="secondary" :disabled="loading" @click="close()">
          {{ $t('prompt.deleteModal.cancelButtonText') }}
        </custom-button>
        <custom-button variant="primary" :busy="loading" :disabled="loading" @click="confirm()">
          {{ $t('prompt.deleteModal.deleteButtonText') }}
        </custom-button>
      </div>
    </div>
  </modal>
</template>

<script setup lang="ts">
import Modal from '@utils/Modal/Modal.vue';
import ModalHeader from '@utils/Modal/ModalHeader.vue';
import CustomButton from '@utils/CustomButton.vue';

interface Props {
  open: boolean;
  loading?: boolean;
  message: string;
}

const props = defineProps<Props>();
const emit = defineEmits(['update:open', 'confirm']);

const close = () => {
  if (props.loading) return;
  emit('update:open', false);
};

const confirm = () => {
  if (props.loading) return;
  emit('confirm');
};
</script>
